import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import axios from 'axios';
import Loading from '../../components/UI/Loading/Loading';
import axiosInstance from '../../api/axiosInstance';
import { useSelector } from "react-redux";

const OrderChat = ({ order, direction, t }) => {
    const [orderHistory, setOrderHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const { isLoggedIn, user, token } = useSelector((state) => state.login);

    useEffect(() => {
        // Fetch Request History
        const fetchRequestHistory = async () => {
            try {
                const response = await axiosInstance.get(`/api/Customer/GetRequestHistory?id=${order.OrderId}`, {
                    headers: {
                        Authorization: `Bearer ${token}` // Send token in Authorization header
                    }
                });                if (response.data.successtate === 200) {
                    setOrderHistory(JSON.parse(response.data.message)); // Parse the response message as JSON
                }
            } catch (error) {
                // console.error('Error fetching request history:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchRequestHistory();
    }, [order.orderId]);
  const [baseURL, setBaseURL] = useState('');
    useEffect(() => {
        // Fetch the config.json to get the baseURL
        const fetchConfig = async () => {
          try {
            const response = await fetch('/config.json');
            const config = await response.json();
            setBaseURL(config.baseURL); 
          } catch (error) {
            // console.error('Error fetching config.json:', error);
          }
        };
    
        fetchConfig();
      }, []);
    if (loading) {
        return <Loading />;
    }
    return (
        <Box mt={4}>
            {/* Date above messages */}
            <Typography
                sx={{
                    textAlign: 'center',
                    fontSize: '12px',
                    fontWeight: 400,
                    color: '#A0A7AF',
                    mb: 2,
                }}
            >
                {order.RequestDate}
            </Typography>

            {/* User Message */}
            <Box sx={{ display: 'flex', justifyContent: direction === "ltr" ? 'flex-end' : 'flex-start', mb: 6 }}>
                <Paper
                    variant="outlined"
                    sx={{
                        padding: 2,
                        borderRadius: '20px 20px 0px 20px',
                        backgroundColor: '#E7F3FF',
                        maxWidth: {md:'70%',xs:'100%'},
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: '14px',
                            fontWeight: 600,
                            lineHeight: '20px',
                            letterSpacing: '0.15px',
                            textAlign: direction === "ltr" ? "left" : "right",
                            textUnderlinePosition: 'from-font',
                            textDecorationSkipInk: 'none',
                            display: 'flex',
                            justifyContent: 'space-between',
                            color: '#12538B',
                            gap:"10px"
                        }}
                    >
                       {order.Customer.CustomerName}({t?.User})
                        <Typography
                            component="span"
                            sx={{
                                fontSize: '14px',
                                fontWeight: 400,
                                lineHeight: '20px',
                                letterSpacing: '0.15px',
                                marginLeft: '8px',
                                color: '#A0A7AF',
                            }}
                        >
                             {t.date}:{order.RequestDate}
                        </Typography>
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: '14px',
                            fontWeight: 400,
                            lineHeight: '20px',
                            letterSpacing: '0.15px',
                            textAlign: direction === "ltr" ? "left" : "right",
                            textUnderlinePosition: 'from-font',
                            textDecorationSkipInk: 'none',
                            mb: "16px",
                            mt: "16px",
                            whiteSpace: 'normal',  
                            wordWrap: 'break-word', 
                        }}
                    >
                        {order.Description}
                    </Typography>
                    {order.OrderFiles && order.OrderFiles.length > 0 && (
                        <Box>
                            {order.OrderFiles.map((file, index) => {
                                // If the FileName is null, extract the file name from the FilePath
                                const fileName = file.FileName || file.FilePath.split('/').pop();
                                let fullFilePath = file.FilePath;                               
                                return (
                                    <Button
                                        key={index}
                                        variant="text"
                                        sx={{
                                            color: '#12538B',
                                            fontSize: '14px',
                                            fontWeight: 600,
                                            textAlign: direction === "ltr" ? "left" : "right",
                                            display: 'block',
                                            mb: 1,
                                            wordBreak: 'break-word',  // Ensures the text breaks at the right point
                                            overflowWrap: 'break-word',  // Allows long words to break onto the next line
                                            whiteSpace: 'normal',
                                        }}
                                        onClick={() => window.open(`${baseURL}/Upload${fullFilePath}`, '_blank')}  // Use the full URL
                                    >
                                        {fileName}  {/* Display the file name */}
                                    </Button>
                                );
                            })}


                        </Box>
                    )}

                </Paper>
            </Box>
            <Box mt={4}>
                {orderHistory.map((historyItem, index) => (
                    <Box key={index}>
                        {/* Date above messages */}
                        <Typography
                            sx={{
                                textAlign: 'center',
                                fontSize: '12px',
                                fontWeight: 400,
                                color: '#A0A7AF',
                                mb: 2,
                            }}
                        >
                            {new Date(historyItem.ActionTime).toLocaleDateString()}
                        </Typography>

                        {/* Message */}
                        <Box sx={{ display: 'flex', justifyContent: direction === "rtl" ? 'flex-end' : 'flex-start', mb: 6 }}>
                            <Paper
                                variant="outlined"
                                sx={{
                                    padding: 2,
                                    borderRadius: '20px 20px 20px 0px',
                                    backgroundColor: "#F1F1F1",
                                    maxWidth: {md:'70%',xs:'100%'},

                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: '14px',
                                        fontWeight: 600,
                                        lineHeight: '20px',
                                        letterSpacing: '0.15px',
                                        textAlign: direction === "ltr" ? "left" : "right",
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        color: '#12538B',
                                         gap:"10px"
                                    }}
                                >
                                    {historyItem.FromUserName} ({t?.Support})
                                    <Typography
                                        component="span"
                                        sx={{
                                            fontSize: '14px',
                                            fontWeight: 400,
                                            color: '#A0A7AF',
                                            marginLeft: '8px',
                                        }}
                                    >
                                        {t.date}: {new Date(historyItem.ActionTime).toLocaleString()}
                                    </Typography>
                                </Typography>

                                <Typography
                                    sx={{
                                        fontSize: '14px',
                                        fontWeight: 400,
                                        lineHeight: '20px',
                                        letterSpacing: '0.15px',
                                        textAlign: direction === "ltr" ? "left" : "right",
                                        mt: '16px',
                                        mb: '16px',
                                        whiteSpace: 'normal',  // Ensures text wraps onto the next line
                                        wordWrap: 'break-word', 
                                    }}
                                >
                                    {historyItem.Action}
                                </Typography>

                                {/* Check for file attachment */}
                                {historyItem.OrderHistoryFiles && historyItem.OrderHistoryFiles.length > 0 && (
                                    <Button
                                        variant="text"
                                        sx={{
                                            color: '#12538B',
                                            fontSize: '14px',
                                            fontWeight: 600,
                                            wordBreak: 'break-word',  // Ensures the text breaks at the right point
                                            overflowWrap: 'break-word',  // Allows long words to break onto the next line
                                            whiteSpace: 'normal',
                                        }}
                                        onClick={() => window.open(`${baseURL}/Upload${historyItem.OrderHistoryFiles[0].FilePath}`, '_blank')} // Combine baseURL with FilePath
                                        >
                                        {historyItem.OrderHistoryFiles[0].FileName}
                                    </Button>
                                )}
                            </Paper>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default OrderChat;
